import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetEventList, apiGetApplyRecord, apiApplyPromotion } from "../service";

export const useGetEventList = (options) => {
  return useQuery(
    [queryKey.EVENT_LIST],
    () => apiGetEventList().then((res) => res.data.data),
    {
      ...options,
    }
  );
};

export const useGetApplyRecord = (options) => {
  return useQuery(
    [queryKey.EVENT_APPLY_RECORD],
    () => apiGetApplyRecord().then((res) => res.data.data),
    {
      ...options,
    }
  );
};

export const useApplyPromotion = () => {
  const cache = useQueryClient();
  return useMutation(
    ({ params, query }) =>
      apiApplyPromotion(params, query).then((res) => res.data.data),
    {
      onSuccess: () => {
        cache.invalidateQueries([queryKey.EVENT_APPLY_RECORD]);
      },
    }
  );
};